/* ============================================================
   Nuitly Pro custom product page — behaviour
   Progressive enhancement only. If JS fails, the product form
   still submits natively to /cart/add and the page stays usable.
   ============================================================ */
(function () {
  'use strict';

  function money(cents) {
    try {
      var fmt = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD';
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: fmt }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var main = root.querySelector('[data-nu-main-img]');
    var thumbs = root.querySelectorAll('[data-nu-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-img');
        if (!src) return;
        var img = main.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          main.insertBefore(img, main.firstChild);
        }
        // Wipe responsive attributes so the new src actually wins.
        // image_tag in Liquid generates srcset/sizes which would otherwise
        // override the .src we just set.
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.removeAttribute('data-srcset');
        img.src = src;
        var alt = t.getAttribute('data-alt');
        if (alt) img.alt = alt;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    // Detect horizontal overflow on the thumb strip and toggle a class so the
    // right-edge fade gradient appears only when there's more to scroll to.
    var strip = root.querySelector('[data-nu-thumbs-wrap]');
    if (strip) {
      var inner = strip.querySelector('.thumbs');
      if (inner) {
        var checkOverflow = function () {
          var atEnd = inner.scrollLeft + inner.clientWidth >= inner.scrollWidth - 4;
          var hasOverflow = inner.scrollWidth > inner.clientWidth + 1;
          if (hasOverflow && !atEnd) strip.classList.add('has-overflow');
          else strip.classList.remove('has-overflow');
        };
        checkOverflow();
        inner.addEventListener('scroll', checkOverflow, { passive: true });
        window.addEventListener('resize', checkOverflow);
      }
    }
  }

  /* ---------- UGC slider ---------- */
  function initUgc(root) {
    var track = root.querySelector('[data-nu-ugc-track]');
    if (!track) return;
    var prev = root.querySelector('[data-nu-ugc-prev]');
    var next = root.querySelector('[data-nu-ugc-next]');
    function step() {
      var card = track.querySelector('.ugc-card');
      return card ? card.getBoundingClientRect().width + 20 : 300;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 1.5, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 1.5, behavior: 'smooth' }); });
  }

  /* ---------- Hero product form (bundles + variants + add to cart) ----------
     Two modes are supported:
       1. VARIANT MODE (preferred). Each bundle button carries
          data-variant-id pointing at a real Shopify variant ID. The
          button click swaps the form's hidden `id` input and sends
          qty=1 (the variant IS the bundle).
       2. QUANTITY MODE (legacy). data-variant-id is empty; the
          button's data-qty becomes the cart quantity. Same product
          variant for all clicks.
  */
  function initForm(root) {
    var form = root.querySelector('[data-nu-cart-form], form.nu-cart-form');
    if (!form) return;

    var qtyInput = form.querySelector('[data-nu-qty]');
    var idInput = form.querySelector('[data-nu-variant-id]');
    var unitPrice = parseInt(root.getAttribute('data-unit-price') || '0', 10);
    var ctaLabels = root.querySelectorAll('[data-nu-cta-label]');
    var bundleBtns = root.querySelectorAll('[data-nu-bundle]');
    var addBase = root.getAttribute('data-add-label') || 'Add to Bag';
    var soldOut = root.getAttribute('data-sold-out') === 'true';
    var ajaxOn = root.getAttribute('data-nu-ajax') !== 'false';

    function setLabel(qty, priceText) {
      ctaLabels.forEach(function (el) {
        el.textContent = priceText ? (addBase + ' — ' + priceText) : addBase;
      });
    }

    function refreshFromQty() {
      var qty = parseInt((qtyInput && qtyInput.value) || '1', 10);
      if (isNaN(qty) || qty < 1) qty = 1;
      var priceText = unitPrice > 0 ? money(unitPrice * qty) : '';
      setLabel(qty, soldOut ? null : priceText);
    }

    function selectBundle(btn) {
      bundleBtns.forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      var vId = btn.getAttribute('data-variant-id');
      if (vId && idInput) idInput.value = vId;
      var dataQty = parseInt(btn.getAttribute('data-qty') || '1', 10);
      if (qtyInput) qtyInput.value = vId ? 1 : dataQty;
      var override = btn.getAttribute('data-price-text');
      if (override) {
        setLabel(dataQty, soldOut ? null : override);
      } else {
        refreshFromQty();
      }
      var sticky = document.querySelector('[data-nu-sticky-qty]');
      if (sticky) sticky.value = String(dataQty);
    }

    bundleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { selectBundle(btn); });
    });

    var defaultBundle = root.querySelector('[data-nu-bundle].is-selected');
    if (defaultBundle && idInput) {
      var dId = defaultBundle.getAttribute('data-variant-id');
      if (dId) idInput.value = dId;
      var dOverride = defaultBundle.getAttribute('data-price-text');
      if (dOverride) setLabel(1, soldOut ? null : dOverride);
    }

    var dec = form.querySelector('[data-nu-qty-dec]');
    var inc = form.querySelector('[data-nu-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(qtyInput.value || '1', 10) - 1; qtyInput.value = v < 1 ? 1 : v; refreshFromQty();
    });
    if (inc) inc.addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1; refreshFromQty();
    });
    if (qtyInput) qtyInput.addEventListener('change', refreshFromQty);

    var variantSelect = form.querySelector('[data-nu-variant-select]');
    if (variantSelect && idInput) {
      variantSelect.addEventListener('change', function () { idInput.value = variantSelect.value; });
    }

    form.addEventListener('submit', function (e) {
      if (!ajaxOn) return;
      e.preventDefault();
      var btn = form.querySelector('[data-nu-submit]');
      var id = idInput ? idInput.value : (form.querySelector('[name="id"]') || {}).value;
      var qty = parseInt((qtyInput && qtyInput.value) || '1', 10);
      if (!id) { form.submit(); return; }
      if (btn) { btn.setAttribute('disabled', 'disabled'); }

      var drawer = document.querySelector('cart-drawer');
      var sectionsToRender = ['cart-icon-bubble'];
      if (drawer && drawer.id) sectionsToRender.push(drawer.id);
      var notification = document.querySelector('cart-notification');
      if (notification && notification.id) sectionsToRender.push(notification.id);

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty }], sections: sectionsToRender, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (btn) btn.removeAttribute('disabled');
          if (!res.ok) { window.location = '/cart'; return; }
          var parsed = res.data;
          var rendered = false;
          try {
            if (notification && typeof notification.renderContents === 'function') { notification.renderContents(parsed); rendered = true; }
            else if (drawer && typeof drawer.renderContents === 'function') { drawer.renderContents(parsed); rendered = true; }
          } catch (err) { rendered = false; }
          try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e2) {}
          try { document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true })); } catch (e3) {}
          if (!rendered) {
            window.location = '/cart';
          }
        })
        .catch(function () { if (btn) btn.removeAttribute('disabled'); window.location = '/cart'; });
    });

    refreshFromQty();
  }

  /* ---------- Sticky ATC ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-nu-sticky]');
    if (!bar) return;
    var anchor = document.querySelector('[data-nu-cta-anchor]');
    var stickyBtn = bar.querySelector('[data-nu-sticky-add]');
    var stickySel = bar.querySelector('[data-nu-sticky-qty]');
    var stickyPrice = bar.querySelector('[data-nu-sticky-price]');

    function syncStickyPrice() {
      if (!stickySel || !stickyPrice) return;
      var opt = stickySel.options[stickySel.selectedIndex];
      if (!opt) return;
      var price = opt.getAttribute('data-price') || '';
      var compare = opt.getAttribute('data-compare') || '';
      stickyPrice.innerHTML = price + (compare ? ' <span class="strike">' + compare + '</span>' : '');
    }
    if (stickySel) { stickySel.addEventListener('change', syncStickyPrice); syncStickyPrice(); }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var heroForm = document.querySelector('[data-nu-cart-form], form.nu-cart-form');
        if (!heroForm) { window.location = '/cart'; return; }
        var qty = stickySel ? parseInt(stickySel.value || '1', 10) : 1;
        var bundle = document.querySelector('[data-nu-bundle][data-qty="' + qty + '"]');
        if (bundle) {
          bundle.click();
        } else {
          var heroQty = heroForm.querySelector('[data-nu-qty]');
          if (heroQty) heroQty.value = qty;
        }
        if (typeof heroForm.requestSubmit === 'function') heroForm.requestSubmit();
        else heroForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }

    if (!anchor) { bar.classList.add('visible'); return; }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.boundingClientRect.top < 0 && !en.isIntersecting) bar.classList.add('visible');
          else if (en.isIntersecting) bar.classList.remove('visible');
        });
      }, { threshold: 0 });
      io.observe(anchor);
    } else {
      window.addEventListener('scroll', function () {
        var r = anchor.getBoundingClientRect();
        if (r.bottom < 0) bar.classList.add('visible'); else bar.classList.remove('visible');
      }, { passive: true });
    }
  }

  /* ---------- Smooth anchor scroll: when arriving at the page with
     a #hash that matches a section that may render late, re-scroll
     after DOM ready so the hash target is reached. */
  function fixAnchorScroll() {
    if (!window.location.hash) return;
    var id = window.location.hash.substring(1);
    if (!id) return;
    var el = document.getElementById(id);
    if (!el) return;
    setTimeout(function () {
      try { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    }, 150);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-nu-hero]').forEach(function (root) {
      initGallery(root); initForm(root);
    });
    (scope || document).querySelectorAll('[data-nu-ugc]').forEach(initUgc);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); fixAnchorScroll(); });
  } else {
    initAll(document);
    fixAnchorScroll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
